import { gql } from '@apollo/client';
import COMMENT_REACTION_FIELDS_FRAGMENT from './fragments/CommentReactionFields';

export default gql`
  subscription commentReactionDeleted($postId: ID!) {
    commentReaction: commentReactionDeleted(postId: $postId) {
      ...CommentReactionFields
      commentId
      threadId
    }
  }
  ${COMMENT_REACTION_FIELDS_FRAGMENT}
`;
